export default __webpack_public_path__ + "media/images/images/banner/banner-14-c8e3e7dc4ed848825b33f94dc90e2cc7.jpg";